import Quill from 'quill';

const Parchment = Quill.import('parchment');

class IndentAttributor extends Parchment.ClassAttributor {
  constructor(name: string, style: string, params: any) {
    super(name, style, params);
  }

  add(node: HTMLElement, value: string) {

    let normalizedValue = 0;
    if (value === '+1' || value === '-1') {
      const indent = this.value(node) || 0;
      normalizedValue = value === '+1' ? indent + 1 : indent - 1;
    } else if (typeof value === 'number') {
      normalizedValue = value;
    }
    if (normalizedValue === 0) {
      this.remove(node);
      return true;
    }

    if (node.tagName === 'P') {
      const padding = parseInt(value);
      if (padding === -1) {
        node.style.paddingLeft = '0';
      } else {
        node.style.paddingLeft = `${padding * 3}em`;
      }

    }
    return super.add(node, normalizedValue.toString());
  }

  value(node) {
    return parseInt(super.value(node), 10) || undefined; // Don't return NaN
  }

}

export const IndentStyle = new IndentAttributor('indent', 'ql-indent', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['1', '2', '3', '4', '5', '6'],

});

